import React, {useState, useContext} from 'react';
import {Grid, Typography} from '@material-ui/core';
import WidgetCard from 'components/WidgetCard';
import {makeStyles} from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {green} from '@material-ui/core/colors';
import ChecklistSection from 'components/widgets/checklists/ChecklistSection';
import ChecklistSectionProfile from 'components/widgets/checklists/ChecklistSectionProfile';
import ChecklistSectionNoToggle from './ChecklistSectionNoToggle';
import ChecklistSectionTrainingDomestic from './ChecklistSectionTrainingDomestic';
import ChecklistSectionTrainingSTCW from './ChecklistSectionTrainingSTCW';
import ChecklistSectionTrainingRadar from './ChecklistSectionTrainingRadar';
import ChecklistSectionMedical from './ChecklistSectionMedical';
import ChecklistSectionFees from './ChecklistSectionFees';
import {RenewalGuideButton} from './GuideButton';
import {useGetApplicationChecklist} from 'hooks';
import {PageTab} from 'components';
import content from 'components/widgets/tooltips/InfoModalContent';
import {UserContext} from 'context/UserContext';
import {ApplicationSubmitButton} from './OriginalChecklist';

const useStyles = makeStyles(theme => ({
    heading: {
        marginBottom: '.5em',
    },
    subheading: {
        marginBottom: '1.5em',
    },

    highlightOffIcon: {
        position: 'absolute',
        top: '1em',
        left: '1em',
    },

    secondaryDescription: {
        border: '.1em solid black',
        borderRadius: '.2em',
        color: theme.palette.text.primary,
        padding: '1em',
    },
}));

const CompleteBanner = allComplete => {
    const classes = useStyles();

    return (
        <Grid container justifyContent='center'>
            <Grid
                item
                style={{
                    color: green[500],
                    marginRight: '2.3em',
                }}
            >
                {allComplete.allComplete ? (
                    <CheckCircleOutlineIcon
                        viewBox='0 0 24 24'
                        className={classes.checkboxIcon}
                        style={{
                            color: green[500],
                            fontSize: '2rem',
                        }}
                    />
                ) : (
                    <HighlightOffIcon
                        viewBox='0 0 24 24'
                        className={classes.checkboxIcon}
                        style={{
                            color: '#828282',
                            fontSize: '2rem',
                        }}
                    />
                )}
            </Grid>

            {allComplete.allComplete ? (
                <Grid
                    item
                    style={{
                        color: green[500],
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                    }}
                >
                    <Typography
                        fontWeight='fontWeightBold'
                        variant='body1'
                        className={classes.subheading}
                        style={{paddingBottom: '0', marginBottom: '0'}}
                    >
                        <strong>Ready to Submit Application</strong>
                    </Typography>
                </Grid>
            ) : (
                <Grid
                    item
                    style={{
                        color: 'gray',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                    }}
                >
                    <Typography
                        fontWeight='fontWeightBold'
                        variant='body1'
                        className={classes.subheading}
                        style={{paddingBottom: '0', marginBottom: '0'}}
                    >
                        <strong>Application Incomplete</strong>
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};

const RenewalChecklist = () => {
    const classes = useStyles();
    const {
        data: checkoffs,
        //    isLoading,
        //    error
    } = useGetApplicationChecklist();
    const {mmlds} = useContext(UserContext);

    const showRadar =
        mmlds?.mmld_docs?.MMC?.filter(item =>
            item?.CAPACITY_DESC?.toLowerCase().includes('radar')
        ).length > 0;

    const showSTCW =
        mmlds?.mmld_docs?.MMC?.filter(item => item?.CAPACITY_TYPE_CD === 'I')
            .length > 0;

    const [ssComplete, setSSComplete] = useState();
    const [trainingComplete, setTrainingComplete] = useState();
    const [medicalComplete, setMedicalComplete] = useState();
    const [mmcComplete, setMmcComplete] = useState();
    const [twicComplete, setTwicComplete] = useState();
    const [drugTestComplete, setDrugTestComplete] = useState();
    const [feesComplete, setFeesComplete] = useState();
    const [profileComplete, setProfileComplete] = useState();
    const [radarComplete, setRadarComplete] = useState();

    //trainingComplete refers to stcw

    const allComplete =
        showRadar && showSTCW
            ? ssComplete &&
              trainingComplete &&
              medicalComplete &&
              mmcComplete &&
              twicComplete &&
              radarComplete &&
              drugTestComplete &&
              feesComplete &&
              profileComplete
            : showRadar && !showSTCW
            ? ssComplete &&
              medicalComplete &&
              mmcComplete &&
              twicComplete &&
              radarComplete &&
              drugTestComplete &&
              feesComplete &&
              profileComplete
            : showSTCW && !showRadar
            ? ssComplete &&
              trainingComplete &&
              medicalComplete &&
              mmcComplete &&
              twicComplete &&
              drugTestComplete &&
              feesComplete &&
              profileComplete
            : ssComplete &&
              medicalComplete &&
              mmcComplete &&
              twicComplete &&
              drugTestComplete &&
              feesComplete &&
              profileComplete;

    return (
        <PageTab>
            <WidgetCard
                title='Renewal MMC Checklist'
                hasData={checkoffs}
                className={classes.widgetCard}
                infoModalContent={content.renewal_checklist}
            >
                <Grid container>
                    <Grid item xs={12} sm={10} style={{margin: 'auto'}}>
                        <Typography
                            fontWeight='fontWeightBold'
                            variant='body1'
                            align='center'
                        >
                            <strong>
                                Follow the Checklist to Make Renewing Easy{' '}
                            </strong>
                        </Typography>
                        <Typography
                            fontWeight='fontWeightBold'
                            variant='body1'
                            align='center'
                            className={classes.subheading}
                        >
                            <strong>
                                These eight steps may seem a little daunting and we
                                agree! If you need any help, reach out!
                            </strong>
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent='center'
                        style={{paddingBottom: '1rem'}}
                    >
                        <RenewalGuideButton />
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={10} style={{margin: 'auto'}}>
                            <ChecklistSection
                                sectionId='renewal_sea_service'
                                checkoffs={checkoffs}
                                complete={ssComplete}
                                setComplete={setSSComplete}
                            />
                            <ChecklistSectionTrainingDomestic
                                sectionId='renewal_training_domestic'
                                checkoffs={checkoffs}
                                mmld={mmlds}
                            />
                            {showSTCW ? (
                                <ChecklistSectionTrainingSTCW
                                    sectionId='renewal_training_stcw'
                                    checkoffs={checkoffs}
                                    complete={trainingComplete}
                                    setComplete={setTrainingComplete}
                                    mmld={mmlds}
                                />
                            ) : null}
                            {showRadar ? (
                                <ChecklistSectionTrainingRadar
                                    sectionId='renewal_training_radar'
                                    checkoffs={checkoffs}
                                    complete={radarComplete}
                                    setComplete={setRadarComplete}
                                />
                            ) : null}
                            <ChecklistSectionMedical
                                sectionId='renewal_medical'
                                checkoffs={checkoffs}
                                complete={medicalComplete}
                                setComplete={setMedicalComplete}
                                mmld={mmlds}
                            />
                            <ChecklistSectionNoToggle
                                sectionId='renewal_photocopy_mmc'
                                checkoffs={checkoffs}
                                complete={mmcComplete}
                                setComplete={setMmcComplete}
                            />
                            <ChecklistSectionNoToggle
                                sectionId='renewal_photocopy_twic'
                                checkoffs={checkoffs}
                                complete={twicComplete}
                                setComplete={setTwicComplete}
                            />
                            <ChecklistSectionNoToggle
                                sectionId='renewal_drug_test'
                                checkoffs={checkoffs}
                                complete={drugTestComplete}
                                setComplete={setDrugTestComplete}
                            />
                            <ChecklistSectionFees
                                sectionId='renewal_fees'
                                checkoffs={checkoffs}
                                complete={feesComplete}
                                setComplete={setFeesComplete}
                            />
                            <ChecklistSectionProfile
                                sectionId='renewal_profile'
                                checkoffs={checkoffs}
                                complete={profileComplete}
                                setComplete={setProfileComplete}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        justifyContent='center'
                        style={{paddingTop: '1rem'}}
                    >
                        <CompleteBanner allComplete={allComplete} />
                        <ApplicationSubmitButton
                            allComplete={allComplete}
                            applicationType='renewal'
                        />
                    </Grid>
                </Grid>
            </WidgetCard>
        </PageTab>
    );
};

export default RenewalChecklist;
